import { render, staticRenderFns } from "./ProductDetailView.vue?vue&type=template&id=dfaabe8e&"
import script from "./ProductDetailView.vue?vue&type=script&lang=js&"
export * from "./ProductDetailView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports